import queryString from "query-string";
import React, { useEffect, useState } from "react";

import { useCustomerServiceApi } from "@api/hooks/customerService.hook";

import { getAuthenticationContext } from "@utils/configuration/aem";

import { useThunkDispatch } from "@redux/dispatcher";
import * as CustomerModule from "@redux/modules/api/data/customer/customer.module";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import ResetPasswordForm from "./resetPasswordForm.component";

const ResetPasswordFormContainer = () => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const [isPreLoading, setPreIsLoading] = useState(true);
    const [hasValidToken, setHasValidToken] = useState(false);

    const [{ loading: isLoadingPassword }, checkPasswordValidity] =
        useCustomerServiceApi<isPasswordTokenValidRequest>(
            {
                url: "/customers/ispasswordtokenvalid",
                method: "GET",
            },
            { manual: true, useCache: false },
        );

    const resetPassword = (password: string, token: string, email: string) => {
        return dispatch(CustomerModule.resetPassword(password, token, email));
    };

    const isPasswordTokenValid = (token: string, email: string) => {
        return checkPasswordValidity({ params: { token, email } });
    };

    useEffect(() => {
        const { PASSWORDRESETTOKEN: token, EMAIL: email } = queryString.parse(
            location.search,
        );

        if (!token || !email) {
            location.assign(getAuthenticationContext().requestPasswordUrl);
        } else {
            isPasswordTokenValid(token as string, email as string)
                .then(() => {
                    setHasValidToken(true);
                })
                .catch(() => {
                    setHasValidToken(false);
                })
                .finally(() => {
                    setPreIsLoading(false);
                });
        }

        return function cleanUp() {
            setPreIsLoading(true);
            setHasValidToken(false);
        };
    }, []);

    const onSubmit = (password: string) => {
        const { PASSWORDRESETTOKEN: token, EMAIL: email } = queryString.parse(
            location.search,
        );

        resetPassword(password, token as string, email as string).then(
            action => {
                if (action.type === CustomerModule.APIStatus.SUCCESS) {
                    location.assign(
                        getAuthenticationContext().loginPageUrl +
                            "?passwordsuccess=true",
                    );
                }
            },
        );
    };

    return (
        <ResetPasswordForm
            buttonText={t("account.resetPassword.submit")}
            onSubmit={onSubmit}
            isLoading={isLoadingPassword}
            isPreLoading={isPreLoading}
            hasValidToken={hasValidToken}
        />
    );
};

export { ResetPasswordFormContainer };
